import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import {
  broadcastUploadedSiteError,
  broadcastUploadedSite,
  broadcastDeletedSite,
  broadcastUpdatedSite,
} from 'serviceWorker/broadcasts/sites';
import { levelSource } from 'serviceWorker/services/levels/levelSource';
import { chooseErrorMessage } from 'shared/utils/errorHandling';

export function broadcastSiteResponse(
  request: HttpRequestEntity,
  response: any
): void {
  if (response.error) {
    const messageId = chooseErrorMessage(response.error);
    return broadcastUploadedSiteError(response.error, messageId, request.data.uniqueId);
  }

  if (request.method === 'POST') {
    // The server creates the site's first level; only a level sync brings it in.
    levelSource.sync();
    return broadcastUploadedSite(response, request.data.uniqueId);
  }

  if (request.method === 'GET') {
    return broadcastUploadedSite(response, request.data.uniqueId);
  }

  if (request.method === 'DELETE') {
    return broadcastDeletedSite(response, request.data.uniqueId);
  }

  return broadcastUpdatedSite(response, request.data.uniqueId);
}
